<div class="data-insights">
  <div class="subtitle">
    <div>{{ 'aiDataInsightsPage.subtitle' | labelsProvider }}</div>
  </div>
  <div style="display: flex; margin-left: 40px; font-weight: bold; margin-top: 20px">
    {{ 'aiDataInsightsPage.sensitiveFiles' | labelsProvider }}
  </div>

  <div style="margin-bottom: 20px; margin-left: 40px">
    <div>{{ 'aiDataInsightsPage.sensitiveFilesDescription' | labelsProvider }}</div>
  </div>

  <div class="table">
    <app-ai-data-insights-vertical-filters
      [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
      (optionOnSelection)="tablesFiltersChange($event)"
      [pageFilters]="pageFilters"
      [isFiltersMenuOpen]="isFiltersMenuOpen"
      (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
    >
    </app-ai-data-insights-vertical-filters>
    <app-prime-table
      #table
      class="table-component"
      queryParamProperty="dataInsights"
      [data$]="dataInsightsCurrentPage$"
      [rowsPerPage]="defaultPageSize"
      [columns]="columns()"
      [isLoading]="(isLoading$ | async) === true"
      [sortedColumn$]="sortedColumn$"
      [pageInfo]="pageInfo$.value"
      (checkedRowsUpdate)="onCheckboxClick($event)"
      (pageOnChange)="onPagination($event)"
      (rowActionOnClick)="actionOnClick($event)"
      [checkedRowsSupportedActions$]="multiSelectedMenuActions$"
      [expandFilterResultControl]="expandFilterResultControl"
      [withCheckboxSelection]="false"
      [withExpandFilters]="false"
      [withActions]="false"
      tableNotFoundText="No data insights found"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
    >
    </app-prime-table>
  </div>
</div>
